export const sortDirections = {
  ASCENDING: 'ASCENDING',
  DESCENDING: 'DESCENDING'
};
